var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4395 21.5752V24.1127C13.4395 26.2627 11.4395 28.0002 8.97697 28.0002C6.51447 28.0002 4.50195 26.2627 4.50195 24.1127V21.5752C4.50195 23.7252 6.50197 25.2502 8.97697 25.2502C11.4395 25.2502 13.4395 23.7127 13.4395 21.5752Z",
    stroke: "#4FAF5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 18.1377C13.4375 18.7627 13.2625 19.3376 12.9625 19.8376C12.225 21.0501 10.7125 21.8127 8.96248 21.8127C7.21248 21.8127 5.69996 21.0376 4.96246 19.8376C4.66246 19.3376 4.48753 18.7627 4.48753 18.1377C4.48753 17.0627 4.98751 16.1002 5.78751 15.4002C6.60001 14.6877 7.71247 14.2627 8.94997 14.2627C10.1875 14.2627 11.3 14.7002 12.1125 15.4002C12.9375 16.0877 13.4375 17.0627 13.4375 18.1377Z",
    stroke: "#4FAF5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4395 18.1375V21.575C13.4395 23.725 11.4395 25.25 8.97697 25.25C6.51447 25.25 4.50195 23.7125 4.50195 21.575V18.1375C4.50195 15.9875 6.50197 14.25 8.97697 14.25C10.2145 14.25 11.327 14.6875 12.1395 15.3875C12.9395 16.0875 13.4395 17.0625 13.4395 18.1375Z",
    stroke: "#4FAF5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14.2124V16.7875C27.5 17.475 26.95 18.0375 26.25 18.0625H23.8C22.45 18.0625 21.2125 17.075 21.1 15.725C21.025 14.9375 21.325 14.2 21.85 13.6875C22.3125 13.2125 22.95 12.9375 23.65 12.9375H26.25C26.95 12.9625 27.5 13.5249 27.5 14.2124Z",
    stroke: "#4FAF5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.625V11.125C2.5 7.725 4.55 5.35 7.7375 4.95C8.0625 4.9 8.4 4.875 8.75 4.875H20C20.325 4.875 20.6375 4.88748 20.9375 4.93748C24.1625 5.31248 26.25 7.7 26.25 11.125V12.9375H23.65C22.95 12.9375 22.3125 13.2125 21.85 13.6875C21.325 14.2 21.025 14.9375 21.1 15.725C21.2125 17.075 22.45 18.0625 23.8 18.0625H26.25V19.875C26.25 23.625 23.75 26.125 20 26.125H16.875",
    stroke: "#4FAF5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/wallet-money.2c1930f5cd90cdf7ecc992a7df8db33a.svg";
export { ForwardRef as ReactComponent };